<template>
  <v-dialog
      v-model="get_dialogReport.show"
      width="900"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-toolbar dense dark color="blue darken-2">
      <v-toolbar-title> <h3>{{ get_dialogReport.tittle }}</h3></v-toolbar-title>
      <v-spacer/>
      <v-btn icon dark @click="get_dialogReport.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

        <v-card-text>
          <h3>Departamentos</h3>
          <v-row>
            <v-col cols="12" class="scroll-box tree-custom">
              <v-treeview
                v-model="selectedItemDepto"
                selectable
                selection-type="independent"
                item-text="nombre"
                item-key="id"
                :items="itemsDepto"
              ></v-treeview>
            </v-col>
          </v-row>
          <v-row>
            <v-combobox
        v-model="selectedEmpleado"
        :items="empleadosFiltrados"
        item-text="ClaveNombre"
        label="Buscar Empleado"
        persistent-hint
        clearable
        multiple
      ></v-combobox>
          </v-row>
          <v-row>
    <v-spacer></v-spacer>
  </v-row>

<v-row v-if="showPDF">
  <iframe
        class="iframe-custom"
        :src=this.pdfPage
        frameborder="0"
        scrolling="no"
        allowfullscreen>
      </iframe>
</v-row>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-3" color="success darken-1" depressed outlined @click="actionDialogoFechas2" :disabled='btnXlsx'>
            Descargar xlsx
          </v-btn>
          <v-btn class="mr-3" color="success darken-1" depressed outlined @click="actionDialogoFechas" :disabled='btnPdf'>
            Descargar PDF
          </v-btn>
        </v-card-actions>
            <v-progress-linear
              :active="progressbar"
              :indeterminate="true"
              absolute
              bottom
              color="blue darken-2 accent-4">
            </v-progress-linear>
      </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios'
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import XLSX from 'xlsx'
export default {
  props: ['dialog2'],
  computed: {
    ...mapGetters(['get_dialogReport', 'get_urls'])
  },
  data () {
    return {
      tipoRpt: 'general',
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      datefin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      progressbar: false,
      dialog: true,
      pdfPage: null,
      selectedItemDepto: [],
      itemsDepto: [],
      selectedEmpleado: null,
      empleados: [],
      empleadosFiltrados: [],
      showPDF: false,
      btnXlsx: false,
      btnPdf: false
    }
  },
  mounted () {
    if (this.get_urls != null) {
      this.getDeptos()
      this.getEmpleados()
    } else {
      this.getUrlServices()
    }
  },
  methods: {
    ...mapActions(['urlGetData', 'getUrExportDataServerAction', 'getUrlServices']),
    async actionDialogoFechas () {
      this.progressbar = true
      const url = this.get_urls['inventario.asignados.reporte']
      this.showPDF = false
      this.btnPdf = true
      this.getDataPDF(url)
    },
    async actionDialogoFechas2 () {
      this.progressbar = true
      const url = this.get_urls['inventario.asignados.reporte']
      this.showPDF = false
      this.btnXlsx = true
      this.getDataXLSX(url)
    },
    getDataPDF (url) {
      const token = Vue.$cookies.get('token')
      const header = { Authorization: `Bearer ${token}` }
      const data = {
        tipo: 'PDF',
        empleados: this.selectedEmpleado,
        departamentos: this.selectedItemDepto
      }
      axios.post(url, data, { headers: header }).then((response) => {
        this.progressbar = false
        this.showPDF = true
        this.btnPdf = false
        // decode base64 string, remove space for IE compatibility
        var binary = atob(response.data.pdf.replace(/\s/g, ''))
        var len = binary.length
        var buffer = new ArrayBuffer(len)
        var view = new Uint8Array(buffer)
        for (var i = 0; i < len; i++) {
          view[i] = binary.charCodeAt(i)
        }
        const blob = new Blob([view], { type: 'application/pdf' })
        this.pdfPage = URL.createObjectURL(blob)
        this.showIframePdf = true
      }).catch((error) => {
        this.progressbar = false
        this.btnPdf = false
        if (error == null) console.log('Error')
      }).finally(() => {
      })
    },
    getDataXLSX (url) {
      const token = Vue.$cookies.get('token')
      const header = { Authorization: `Bearer ${token}` }
      const data = {
        tipo: 'XLSX',
        empleados: this.selectedEmpleado,
        departamentos: this.selectedItemDepto
      }
      axios.post(url, data, { headers: header }).then((response) => {
        this.progressbar = false
        this.btnXlsx = false
        const nombre = this.get_dialogReport.tittle
        const data = XLSX.utils.json_to_sheet(response.data)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, data, 'data')
        XLSX.writeFile(wb, `${nombre}.xlsx`)
      }).catch((error) => {
        this.progressbar = false
        this.btnXlsx = false
        if (error == null) console.log('Error')
      }).finally(() => {
      })
    },
    getDeptos () {
      const token = Vue.$cookies.get('token')
      const header = { Authorization: `Bearer ${token}` }

      const url = this.get_urls['empresa.departamentos.children']
      axios.get(url, { headers: header }).then((response) => {
        this.itemsDepto = response.data
      }).catch((error) => {
        if (error == null) console.log('Error')
      }).finally(() => {
      })
    },
    getEmpleados () {
      const token = Vue.$cookies.get('token')
      const header = { Authorization: `Bearer ${token}` }
      const url = this.get_urls['empresa.empleados.all']
      axios.get(url, { headers: header }).then((response) => {
        this.empleados = response.data
        this.empleadosFiltrados = this.empleados
      }).catch((error) => {
        if (error == null) console.log('Error')
      }).finally(() => {
      })
    }
  },
  watch: {
    selectedItemDepto (val) {
      if (val) {
        this.empleadosFiltrados = this.empleados.filter(item => val.includes(item.departamento_id))
      }
    },
    get_urls (val) {
      this.getDeptos()
      this.getEmpleados()
    }
  }
}
</script>

<style scoped>
.iframe-custom {
  width: 100%;
  height: 50vh;
}
.tree-custom {
  width: 100%;
  height: 25vh;
}
</style>
